import graphql from "babel-plugin-relay/macro";

const WalletDataQuery = graphql`
    query WalletDataQuery($userId:String!) {
        allWallet(userId : $userId,first:1)
        {
           edges{
              node{
                user{
                  id
                  username
                  avatar
                }
                availableDeposit
                availableEarnings
                availableGrantMoney
                balance
                cashBalance
                availableNettWorth
               shortUsername
              }
           }
        }
        
    }
`;

export default WalletDataQuery;
